import { useTranslation } from 'react-i18next'

const TeenageRoom = (props) => {
  const { t } = useTranslation()
  
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 1920 1080"
      role="image"
      aria-labelledby="teenageroom-title"
      xmlSpace="preserve"
      {...props}
    >
      <title id="teenageroom-title">{t('antagonists:relative:components:background')}</title>
      <defs>
        <clipPath id="b">
          <path
            style={{
              fill: 'none',
            }}
            d="M0 0h1920v1080H0z"
          />
        </clipPath>
        <clipPath id="c">
          <path
            style={{
              fill: '#c3e3e8',
            }}
            d="m120.09 189.6 2.67 215.78 165.3.7.05-217.43-168.02.95z"
          />
        </clipPath>
        <clipPath id="d">
          <path
            d="M983.67 505.29c-74.97 3.7-142.46-17.8-175.69 51.84-9.75 20.42-10.64 50.84-24.11 86.66-14.89 39.61-41.72 84.28-36.95 95.02 16.42 36.94 107.29-15.04 163.61-3.59 56.32 11.45 88.09 30.35 198.82 22.71 110.73-7.64 359.79-18.74 446.97-6.81 92.33 12.64 344.91 12.02 384.05 12.02 39.14 0 89.79-11.08 103.15-25.4 13.36-14.32-21.89-136.3-33.35-171.62-11.45-35.32-13.05-49.17-72.24-53.95-59.18-4.77-876.94-10.71-954.26-6.89Z"
            style={{
              fill: '#ed7703',
            }}
          />
        </clipPath>
        <clipPath id="e">
          <path
            d="M1606.78 266.9c-4.8 10.81 0 76.7-2.64 129.59s-37.03 105.79-21.16 116.37c15.87 10.58 113.72 13.22 169.26 13.22 55.54 0 185.13 29.09 195.71 13.22 10.58-15.87 0-95.21 7.93-126.95 7.93-31.74 26.45-105.79 15.87-113.72-10.58-7.93-126.95-10.58-177.2-18.51-50.25-7.93-177.2-37.03-187.78-13.22Z"
            style={{
              fill: '#008389',
            }}
          />
        </clipPath>
        <clipPath id="f">
          <path
            d="M1249.56 375.96c0 10.38 12.45 39.43 8.3 64.34-4.15 24.9-24.9 89.24-14.53 93.39 10.38 4.15 97.54-2.08 118.29 2.08 20.75 4.15 62.26-2.08 78.86-8.3 16.6-6.23 6.23-87.16 8.3-107.92 2.08-20.75 12.45-66.41 6.23-78.86-6.23-12.45-62.26-4.15-85.09-4.15-22.83 0-120.37 20.75-120.37 39.43Z"
            style={{
              fill: '#fcf8f1',
            }}
          />
        </clipPath>
        <clipPath id="g">
          <path
            d="M1429.76 465.81c-6.45 27.96-32.91 77.05-17.46 85.87 15.45 8.83 143.28.21 189.63 4.63 46.35 4.41 123.61 8.83 130.23 2.21 6.62-6.62 11.04-50.77 11.04-66.22 0-15.45 19.87-64.01 8.83-72.84-11.04-8.83-119.2 13.24-163.34 8.83s-128.03-35.32-147.89-28.7c-19.87 6.62-4.41 37.52-11.04 66.22Z"
            style={{
              fill: '#009f65',
            }}
          />
        </clipPath>
        <clipPath id="h">
          <path
            style={{
              fill: '#fcf8f1',
            }}
            d="m440.59 251.45 1.5 117.34 171.34-.09-.69-119.05-172.15 1.8z"
          />
        </clipPath>
        <style>
          {
            '.j{fill:none}.k{fill:#f3f4f0}.l{fill:#f7c4ce}.m{fill:#00ace1}.n{fill:#00a79b}.o{fill:#008389}.p{fill:#ed7703}.q{fill:#ec7527}.r{fill:#ffe547}.s{fill:#ffe251}.t{fill:#f39948}.u{fill:#fee608}.v{fill:#fbe91e}.w{fill:#e5f2ee}.x{fill:#e85627}.y{fill:#e8523b}.aa{fill:#fdf9f3}.ab{fill:#009f65}.ac{fill:#bac4cb}.ad{fill:#bb5396}.ae{fill:#a68953}.af{fill:#ab9137}.ag{fill:#dac38a}.ah{fill:#d7ebee}.ai{fill:#b2c9d1}.aj{fill:#cfe6ea}.ak{fill:#c3e3e8}.al{fill:#dcded9}.am{fill:#a93985}.an{fill:#428a3d}.ao{fill:#352e50}.ap{fill:#3d3c50}.aq{fill:#5e626c}.ar{fill:#501f74}.as{fill:#82b556}.at{fill:#7bb2dd}.au{clip-path:url(#c)}.av{clip-path:url(#b)}.aw{clip-path:url(#f)}.ax{clip-path:url(#e)}.ay{clip-path:url(#d)}.ba{clip-path:url(#g)}'
          }
        </style>
      </defs>
      <g
        style={{
          clipPath: 'url(#b)',
        }}
        id="a"
      >
        <path
          style={{
            fill: '#dcded9',
          }}
          d="M-203.44-87.89h2431.61v1442.67H-203.44z"
        />
        <path
          id="ENVIRONMENT_BACKGROUND"
          style={{
            fill: '#bac4cb',
          }}
          d="m-153.54 693.97 2158.83-29.21 55.5 686.5-2220.18-8.77 5.85-648.52z"
        />
        <path
          style={{
            fill: '#f3f4f0',
          }}
          d="m197.79 801.32-.34-327.97-144.89.49v-3.77l-116.84-1.04-.61 331.73 262.68.56z"
        />
        <path
          style={{
            fill: '#b2c9d1',
          }}
          d="m172.7 498.52-67.24-.57-9.15 10.98-42.79-.21-8.71-11.28-66.32-.55-.32 63.6 194.85 3.3-.32-65.27zM171.76 572.94l-66.01-.94-9.59 11.51-42.79-.21-9.4-12.17-65.47-.93.63 60.3 193.26 1.07-.63-58.63zM173.19 640.37l-66.07-.37-10.17 12.19-42.79-.21-9.52-12.33-65.03-.36-.64 56.41 194.53 1.08-.31-56.41zM172.12 707.85l-66.07-.37-10.17 12.19-42.78-.21-9.53-12.33-65.03-.36-.64 56.41 194.53 1.08-.31-56.41z"
        />
        <path
          style={{
            fill: '#fdf9f3',
          }}
          d="m63.86 143.64.52 321.96 282.96-.28-4.95-324.68-278.53 3z"
        />
        <path
          style={{
            fill: '#c3e3e8',
          }}
          d="m120.09 189.6 2.67 215.78 165.3.7.05-217.43-168.02.95z"
        />
        <g
          style={{
            clipPath: 'url(#c)',
          }}
        >
          <path
            style={{
              fill: '#e5f2ee',
            }}
            d="m95.45 299.74 290.65-85.49 6.68 229.09-297.34 83.57.01-227.17z"
          />
          <path
            style={{
              fill: '#d7ebee',
            }}
            d="m60.12 201.51 290.65-85.49 6.69 229.09-297.34 83.57V201.51z"
          />
          <path
            style={{
              fill: '#c3e3e8',
            }}
            d="M93.44 307.97 372.79 154.6l21.44 274.71-297.34 83.57-3.45-204.91z"
          />
          <path
            style={{
              fill: '#cfe6ea',
            }}
            d="m81.13 366.11 290.65-85.5 6.69 229.1-297.35 83.57.01-227.17z"
          />
        </g>
        <path
          style={{
            fill: '#fcf8f1',
          }}
          d="m1415.11 113.85-33.75 122.02 96.59 27.16 30.72-121.99-93.56-27.19z"
        />
        <path
          d="M1454.81 148.04s-4.31-17.5-20.81-16.48c-16.5 1.02-15.48 17.52-13.81 31.82 1.68 14.3 11.08 44.73 11.08 44.73s26.91-11.67 39.75-26.38c12.84-14.72 19.42-32.52 9.42-39.14-10-6.62-25.64 5.45-25.64 5.45Z"
          style={{
            fill: '#e85627',
          }}
        />
        <path
          d="M1464.25 201.95s7.89-5.33 14 .92c6.11 6.24-.14 12.35-5.86 17.36-5.73 5.01-20.19 13.6-20.19 13.6s-6.41-14.11-6.23-24.42c.18-10.31 3.91-19.62 10.18-18.67 6.26.95 8.12 11.22 8.12 11.22Z"
          style={{
            fill: '#bb5396',
          }}
        />
        <path
          style={{
            fill: '#dac38a',
          }}
          d="m1462.59 115.61-6.31 15.7 9.89 2.74 6.17-15.32-9.75-3.12z"
        />
        <path
          style={{
            fill: '#f3f4f0',
          }}
          d="M540.03 474.69 413.46 806.8l25.37-1.11 124.38-331.57-23.18.57z"
        />
        <path
          style={{
            fill: '#428a3d',
          }}
          d="m373.52 390.53-4.04-49.77 5.69-.91 5.31 48.15-6.96 2.53z"
        />
        <path
          style={{
            fill: '#ec7527',
          }}
          d="m368.31 437.56 24.24-91.81 4.94 1.57-22.44 93.32-6.74-3.08z"
        />
        <path
          style={{
            fill: '#f3f4f0',
          }}
          d="m569.02 478.37 119.39 330.29-25.63.57-115.65-328.19 21.89-2.67z"
        />
        <path
          style={{
            fill: '#a68953',
          }}
          d="m881.9 783.93 11.29 117.36h29.93l10.57-113.83-51.79-3.53zM1864.97 799.61l11.29 117.37h29.93l10.57-113.84-51.79-3.53z"
        />
        <path
          d="M881.96 546.87c-45.22 8.82-55.34 18.14-61.09 62.05-17.41 133-42.51 219.69-42.51 219.69s68.21 24.3 182.83 18.96c108.02-5.03 745.17 6.58 908.3 16.57 77.9 4.77 168.74-42.61 173.18-40.02 0 0-26-97.18-30.78-161.13-4.77-63.96-18.81-134.24-61.77-134.24-42.96 0-408.56-3.82-544.11-4.77-135.55-.95-484.92 15.27-524.06 22.91Z"
          style={{
            fill: '#f7c4ce',
          }}
        />
        <path
          d="M983.67 505.29c-74.97 3.7-142.46-17.8-175.69 51.84-9.75 20.42-10.64 50.84-24.11 86.66-14.89 39.61-41.72 84.28-36.95 95.02 16.42 36.94 107.29-15.04 163.61-3.59 56.32 11.45 88.09 30.35 198.82 22.71 110.73-7.64 359.79-18.74 446.97-6.81 92.33 12.64 344.91 12.02 384.05 12.02 39.14 0 89.79-11.08 103.15-25.4 13.36-14.32-21.89-136.3-33.35-171.62-11.45-35.32-13.05-49.17-72.24-53.95-59.18-4.77-876.94-10.71-954.26-6.89Z"
          style={{
            fill: '#ed7703',
          }}
        />
        <g
          style={{
            clipPath: 'url(#d)',
          }}
        >
          <path
            d="M821.31 573.05c94.63 6.3 537.25 2.6 703.93 10.5 166.68 7.9 576.29 22.31 609.73 2.97 33.44-19.34 33.93-168.33 33.93-168.33L797.74 393.78l-130.63 64.56s10.46 105.14 154.21 114.71Z"
            style={{
              fill: '#f39948',
            }}
          />
          <path
            d="M884.79 555.39c94.63 6.3 537.25 2.6 703.93 10.5 166.68 7.9 576.29 22.31 609.73 2.97 33.44-19.34 33.93-168.33 33.93-168.33L861.22 376.12l-152.6 94.98s32.42 74.72 176.17 84.28Z"
            style={{
              fill: '#ed7703',
            }}
          />
        </g>
        <path
          d="M1606.78 266.9c-4.8 10.81 0 76.7-2.64 129.59s-37.03 105.79-21.16 116.37c15.87 10.58 113.72 13.22 169.26 13.22 55.54 0 185.13 29.09 195.71 13.22 10.58-15.87 0-95.21 7.93-126.95 7.93-31.74 26.45-105.79 15.87-113.72-10.58-7.93-126.95-10.58-177.2-18.51-50.25-7.93-177.2-37.03-187.78-13.22Z"
          style={{
            fill: '#008389',
          }}
        />
        <g
          style={{
            clipPath: 'url(#e)',
          }}
        >
          <path
            d="M1543.3 288.06s224.8 29.09 282.99 34.38c58.18 5.29 195.71 10.58 195.71 10.58v39.67s-129.59 5.29-222.16-10.58c-92.57-15.87-264.47-26.45-264.47-26.45l7.93-47.61ZM1535.37 380.62s177.2 26.45 261.83 29.09c84.63 2.64 201 0 201 0v39.67s-103.15 7.93-198.36-2.64c-95.21-10.58-277.7-23.8-277.7-23.8l13.22-42.32ZM1514.21 491.7c7.93 0 190.42 7.93 267.12 13.22 76.7 5.29 222.16 23.8 222.16 23.8l-7.93 103.15-444.32-21.16-37.03-119.01Z"
            style={{
              fill: '#00ace1',
            }}
          />
        </g>
        <path
          d="M1249.56 375.96c0 10.38 12.45 39.43 8.3 64.34-4.15 24.9-24.9 89.24-14.53 93.39 10.38 4.15 97.54-2.08 118.29 2.08 20.75 4.15 62.26-2.08 78.86-8.3 16.6-6.23 6.23-87.16 8.3-107.92 2.08-20.75 12.45-66.41 6.23-78.86-6.23-12.45-62.26-4.15-85.09-4.15-22.83 0-120.37 20.75-120.37 39.43Z"
          style={{
            fill: '#fcf8f1',
          }}
        />
        <g
          style={{
            clipPath: 'url(#f)',
          }}
        >
          <path
            d="M1366.92 498.32c-33.08 9.27-80.85-4.62-86.36-52.98-5.51-48.43 29.03-73.38 53.84-76.35 34.95-4.21 70.44 11.22 80.28 50.74 8.54 34.33-12.61 68.76-47.77 78.59Z"
            style={{
              fill: '#a93985',
            }}
          />
          <path
            d="M1344.88 389.35c-4.02-9.9-14.98-11.62-24.78-7.43-9.77 4.18-14.58 12.8-11.08 22.86 1.49 4.27 6.81 7.47 5.79 9.25-1.03 1.78-10.62-2.62-15.95-.36-9.81 4.2-14.35 15.57-10.18 25.36 4.14 9.63 15.14 14.19 24.84 10.36l.02.02c-8.15 4.88-11.7 15.16-7.84 24.16 4.18 9.81 15.52 14.35 25.31 10.17 5.84-2.49 9.84-13.68 11.21-13.24s1.37 5.36 2.11 7.13c4.19 9.8 16.04 13.12 25.83 8.92 9.8-4.18 13.16-16.02 8.96-25.85-1.11-2.6-5.9-5.15-4.74-6.65 1.16-1.5 11.69 2.36 17.51 1.28 12.08-2.23 13.07-16.33 8.89-26.12-4.14-9.73-25.02-8.61-25.03-10.29s14.1-9.3 8.21-24.39c-3.88-9.93-15.51-14.37-25.3-10.16-6.97 2.99-10.56 16.61-11.7 16.66s.34-5.72-2.07-11.66Z"
            style={{
              fill: '#e8523b',
            }}
          />
        </g>
        <path
          d="M1348.27 448.78c-9.33 2.61-22.81-1.3-24.36-14.94-1.55-13.66 8.19-20.7 15.19-21.54 9.86-1.19 19.87 3.17 22.64 14.31 2.41 9.68-3.56 19.39-13.47 22.17Z"
          style={{
            fill: '#00a79b',
          }}
        />
        <path
          d="M1429.76 465.81c-6.45 27.96-32.91 77.05-17.46 85.87 15.45 8.83 143.28.21 189.63 4.63 46.35 4.41 123.61 8.83 130.23 2.21 6.62-6.62 11.04-50.77 11.04-66.22 0-15.45 19.87-64.01 8.83-72.84-11.04-8.83-119.2 13.24-163.34 8.83s-128.03-35.32-147.89-28.7c-19.87 6.62-4.41 37.52-11.04 66.22Z"
          style={{
            fill: '#009f65',
          }}
        />
        <g
          style={{
            clipPath: 'url(#g)',
          }}
        >
          <path
            d="M1515.33 521c-12.84-3.69-13.72-17.82-11.26-25.62 2.51-7.83 10.23-16.27 5.72-20.21-4.52-3.96-10.6 7.34-20.82 12.32-22.56 11.02-34.71-15.24-18.01-24.81 16.69-9.58 24.72-7.55 25.42-12.15.73-4.59-9.54-7.47-16.71-13.4-7.76-6.37-12.15-17.49-2.31-26.97 9.82-9.48 18.09-5.19 25.7 3.63 5.22 6.02 6.28 22.03 12.16 20.59 5.85-1.5 9.41-14.97 19.93-23.01 12.82-9.89 28.21 2.62 26.74 16.36-1.23 11.45-19.62 16.21-20.32 23.27-.59 6.07 9.52 3.74 26.45 7.21 18.2 3.76 15.03 29.66-1.83 29.48-16.86-.16-29.59-15.22-35.06-8.41-4.03 5.04 6.61 13.74 7.03 23.17.8 17.87-8.08 22.78-22.83 18.54Z"
            style={{
              fill: '#82b556',
            }}
          />
          <path
            d="M1514.14 444.36c-5.73 1.28-11.01 8.53-8.91 15.36 2.24 7.38 9.61 11.33 16.81 9.21 5.63-1.66 9.98-6.69 8.51-14.95-1.02-5.66-8.05-11.53-16.41-9.63Z"
            style={{
              fill: '#352e50',
            }}
          />
          <path
            d="M1627.94 587.82c-12.84-3.69-13.72-17.82-11.26-25.62 2.51-7.83 10.23-16.27 5.72-20.21-4.52-3.96-10.6 7.34-20.82 12.32-22.56 11.02-34.71-15.24-18.01-24.81 16.69-9.58 24.72-7.55 25.42-12.15.73-4.59-9.54-7.47-16.71-13.4-7.76-6.37-12.15-17.49-2.31-26.97 9.82-9.48 18.09-5.19 25.7 3.63 5.22 6.02 6.28 22.03 12.16 20.59 5.85-1.5 9.41-14.97 19.93-23.01 12.82-9.89 28.21 2.62 26.74 16.36-1.23 11.45-19.62 16.21-20.32 23.27-.59 6.07 9.52 3.74 26.45 7.21 18.2 3.76 15.03 29.66-1.83 29.48-16.86-.16-29.59-15.22-35.06-8.41-4.03 5.04 6.61 13.74 7.03 23.17.8 17.87-8.08 22.78-22.83 18.54Z"
            style={{
              fill: '#82b556',
            }}
          />
          <path
            d="M1626.74 511.18c-5.73 1.28-11.01 8.53-8.91 15.36 2.24 7.38 9.61 11.33 16.81 9.21 5.63-1.66 9.98-6.69 8.51-14.95-1.02-5.66-8.05-11.53-16.41-9.63Z"
            style={{
              fill: '#352e50',
            }}
          />
          <path
            d="M1707.98 506.36c-12.84-3.69-13.72-17.82-11.26-25.62 2.51-7.83 10.23-16.27 5.72-20.21-4.52-3.96-10.6 7.34-20.82 12.32-22.56 11.02-34.71-15.24-18.01-24.81 16.69-9.58 24.72-7.55 25.42-12.15.73-4.59-9.54-7.47-16.71-13.4-7.76-6.37-12.15-17.49-2.31-26.97 9.82-9.48 18.09-5.19 25.7 3.63 5.22 6.02 6.28 22.03 12.16 20.59 5.85-1.5 9.41-14.97 19.93-23.01 12.82-9.89 28.21 2.62 26.74 16.36-1.23 11.45-19.62 16.21-20.32 23.27-.59 6.07 9.52 3.74 26.45 7.21 18.2 3.76 15.03 29.66-1.83 29.48-16.86-.16-29.59-15.22-35.06-8.41-4.03 5.04 6.61 13.74 7.03 23.17.8 17.87-8.08 22.78-22.83 18.54Z"
            style={{
              fill: '#82b556',
            }}
          />
          <path
            d="M1706.78 429.71c-5.73 1.28-11.01 8.53-8.91 15.36 2.24 7.38 9.61 11.33 16.81 9.21 5.63-1.66 9.98-6.69 8.51-14.95-1.02-5.66-8.05-11.53-16.41-9.63Z"
            style={{
              fill: '#352e50',
            }}
          />
        </g>
        <path
          style={{
            fill: '#7bb2dd',
          }}
          d="m1566.71 77.86 23.52 168.15 132.2-21.49-30.27-166.6-125.45 19.94z"
        />
        <path
          style={{
            fill: '#fbe91e',
          }}
          d="m1624.14 46.92 6.26 32.11 14.1-3.13-9.4-31.33-10.96 2.35z"
        />
        <path
          d="M1684.64 175.48c-7.27-15.88-11.28-27.27-11.21-34.25.11-10.36 8.72-20.37 8.72-20.37l-3.62-2.26s-13.58 9.05-12.42 25.21c.7 9.75 8.36 26.82 11.92 34.59 5.24 11.4 8.09 21.19 2.46 26.32-4.3 3.92-14.13.7-16.32-2.11-.26-.33 1.88-40.01-17.67-55.77-7.67-6.18-14.69-4.89-15-7.53-.31-2.64 1.82-6.56 2.44-11.3.79-6.05-.76-11.2-.76-11.2l1.77-9.81-10.88 4.74s-3.19-1.28-6.7-1.36c-3.85-.09-7.31.77-7.31.77l-10.97-4.36 1.84 9.15s-1.47 8.98-.58 13.51c1.31 6.68 4.09 10.34 4.39 13.35.3 3.01-4.29 6.66-4.14 15.68.15 9.02 4.85 13.17 6.51 22.22 1.66 9.06.88 20.18.39 25.05-.49 4.87-2.13 6.94-2.25 11.45-.11 4.5 6.69 1.43 6.69 1.43s4.78-5.41 5.62-9.15c.84-3.73 1-10.06 1.08-13.52.09-3.54 2.77-3.98 3.41.54.64 4.52 1.85 7.25 1.38 10.99-.47 3.74-4.04 7.57-4.25 10.3-.34 4.33 7.51 1.2 7.51 1.2s6.74-5.62 7.2-8.99c.46-3.37-1.2-14.38.07-14.81 1.42-.48 2.22 6.27 4.12 9.01 2.9 4.2 6.29 3.92 6.38 5.07.19 2.26-3.7 2.31-6.36 3.5-2.92 1.31-1.4 6.07-1.4 6.07s5.81-.33 11.72-1.63c3.86-.85 15.14-5.05 15.14-5.05s15.34 2.78 21.18-1.02c8.9-5.79 6.98-20.16-.11-35.64Z"
          style={{
            fill: '#501f74',
          }}
        />
        <path
          d="M1619.93 126.2s0-2.54 2.25-3.46c2.26-.92 4.37.2 4.37.2s-.54 2.52-2.08 3.29c-2.3 1.15-4.54-.04-4.54-.04ZM1613.35 126.3s0-2.54-2.25-3.46c-2.26-.92-4.37.2-4.37.2s.54 2.52 2.08 3.29c2.3 1.15 4.54-.04 4.54-.04Z"
          style={{
            fill: '#ffe251',
          }}
        />
        <path
          style={{
            fill: '#5e626c',
          }}
          d="m511.31 323.75-18.62 139.22 68.53-2.12-16.41-137.07-33.5-.03z"
        />
        <path
          style={{
            fill: '#fcf8f1',
          }}
          d="m440.59 251.45 1.5 117.34 171.34-.09-.69-119.05-172.15 1.8z"
        />
        <g
          style={{
            clipPath: 'url(#h)',
          }}
        >
          <path
            d="M485.89 316.01s45.33 2.22 87.06 2.22c41.72 0 90.97-6.52 90.97-6.52l-1.85 91.48-157.63 9.15-18.54-96.33Z"
            style={{
              fill: 'none',
            }}
          />
        </g>
        <path
          d="M354.19 373.64c5.41-2.62 10.83-4.19 10.83-4.19l-.7-2.27-16.94 1.57-.1-.76 16.64-2.26-.07-1.41-16.86 1.52-.14-1.01 16.78-2.28-.07-1.41-16.99 1.53-.15-1.14 17.11-2.33-.07-1.41-17.34 1.56-.13-.95 17.42-2.37-.07-1.41-17.64 1.59-.18-1.35 17.45-2.37-.07-1.41-17.68 1.59-.16-1.22 16.34-3.62-.19-1.4-16.44 2.87-.14-1.02 16.22-3.59-.19-1.4-16.32 2.85-.16-1.16 16.28-3.61-.19-1.4-16.38 2.86-.13-.99 16.32-3.61-.19-1.4-16.42 2.87-.19-1.4 16.07-3.56-.19-1.4-16.17 2.82-.11-.79 16.35-3.62-.19-1.4-16.45 2.87-.13-.99 16.39-3.63-.19-1.4-16.49 2.88-.19-1.4 16.14-3.57-.19-1.4-16.24 2.83-.12-.88 16.27-3.45-.17-1.4-16.38 2.7-.14-1.03 16.17-3.43-.17-1.4-16.28 2.69-.16-1.16 16.26-3.45-.17-1.4-16.38 2.7-.13-.99 16.33-3.46-.17-1.4L340 313.9l-.19-1.4 16.11-3.41-.17-1.4-16.22 2.68-.2-1.46 15.9-3.14.17-2.45s-6.81-.17-14.15.87c-7.34 1.05-10.83.7-11.88 8.56-1.05 7.86 8.56 58.34 10.31 65.68s4.37 55.72 4.37 55.72l16.07-.17s-11.35-57.82-5.94-60.44Z"
          style={{
            fill: '#3d3c50',
          }}
        />
        <path
          style={{
            fill: '#fee608',
          }}
          d="m339.04 386.05 5.09 77.79 42.86 1.46 9.44-79.25h-57.39z"
        />
        <path
          d="M89.33 391.62c-5.37 1.2-10.32 7.99-8.35 14.4 2.1 6.92 9.01 10.62 15.75 8.63 5.28-1.55 9.35-6.27 7.98-14.01-.95-5.3-7.55-10.8-15.38-9.02ZM89.33 347.17c-5.37 1.2-10.32 7.99-8.35 14.4 2.1 6.92 9.01 10.62 15.75 8.63 5.28-1.55 9.35-6.27 7.98-14.01-.95-5.3-7.55-10.8-15.38-9.02ZM89.33 302.71c-5.37 1.2-10.32 7.99-8.35 14.4 2.1 6.92 9.01 10.62 15.75 8.63 5.28-1.55 9.35-6.27 7.98-14.01-.95-5.3-7.55-10.8-15.38-9.02ZM89.33 258.26c-5.37 1.2-10.32 7.99-8.35 14.4 2.1 6.92 9.01 10.62 15.75 8.63 5.28-1.55 9.35-6.27 7.98-14.01-.95-5.3-7.55-10.8-15.38-9.02ZM89.33 213.8c-5.37 1.2-10.32 7.99-8.35 14.4 2.1 6.92 9.01 10.62 15.75 8.63 5.28-1.55 9.35-6.27 7.98-14.01-.95-5.3-7.55-10.8-15.38-9.02ZM89.33 169.35c-5.37 1.2-10.32 7.99-8.35 14.4 2.1 6.92 9.01 10.62 15.75 8.63 5.28-1.55 9.35-6.27 7.98-14.01-.95-5.3-7.55-10.8-15.38-9.02ZM313.17 390.04c-5.37 1.2-10.32 7.99-8.35 14.4 2.1 6.92 9.01 10.62 15.75 8.63 5.28-1.55 9.35-6.27 7.98-14.01-.95-5.3-7.55-10.8-15.38-9.02ZM313.17 345.59c-5.37 1.2-10.32 7.99-8.35 14.4 2.1 6.92 9.01 10.62 15.75 8.63 5.28-1.55 9.35-6.27 7.98-14.01-.95-5.3-7.55-10.8-15.38-9.02ZM313.17 301.14c-5.37 1.2-10.32 7.99-8.35 14.4 2.1 6.92 9.01 10.62 15.75 8.63 5.28-1.55 9.35-6.27 7.98-14.01-.95-5.3-7.55-10.8-15.38-9.02ZM313.17 256.68c-5.37 1.2-10.32 7.99-8.35 14.4 2.1 6.92 9.01 10.62 15.75 8.63 5.28-1.55 9.35-6.27 7.98-14.01-.95-5.3-7.55-10.8-15.38-9.02ZM313.17 212.23c-5.37 1.2-10.32 7.99-8.35 14.4 2.1 6.92 9.01 10.62 15.75 8.63 5.28-1.55 9.35-6.27 7.98-14.01-.95-5.3-7.55-10.8-15.38-9.02ZM313.17 167.77c-5.37 1.2-10.32 7.99-8.35 14.4 2.1 6.92 9.01 10.62 15.75 8.63 5.28-1.55 9.35-6.27 7.98-14.01-.95-5.3-7.55-10.8-15.38-9.02Z"
          style={{
            fill: '#ffe547',
          }}
        />
        <path
          style={{
            fill: '#ab9137',
          }}
          d="m-.38 484.84 646.45.25-.32-23.09-646.1-2.83-.03 25.67z"
        />
      </g>
    </svg>
  )
}

export default TeenageRoom
